export default {
  list: {
    searchPlaceholder: 'Cari Alamat',
    addAddress: 'Tambah Alamat',
    dataNotFound: 'Maaf data tidak ditemukan!'
  },
  add: {
    title: 'Tambah Lokasi',
    addressLabel: 'Label',
    addressLabelPlaceholder: 'Ex: Rumah, Kantor',
    senderName: 'Nama',
    senderNamePlaceholder: 'Masukan nama',
    phone: 'No Handphone',
    phonePlaceholder: 'Masukan no handphone',
    selectIcon: 'Pilih Icon',
    searchAddress: 'Kelurahan / Kecamatan',
    searchAddressPlaceholder: 'Cari Kelurahan / Kecamatan',
    mapLocation: 'Lokasi Peta',
    searchLocation: 'Cari lokasi...',
    address: 'Alamat',
    addressPlaceholder: 'Masukan alamat',
    detailAddress: 'Detail / Patokan Alamat',
    detailAddressPlaceholder: 'Masukan detail alamat',
    mainAddress: 'Set sebagai alamat utama',
    cancel: 'Batal',
    save: 'Simpan',
    dataNotFound: 'Maaf data tidak ditemukan!',
    loading: 'Memuat...',
    selectLocation: 'Pilih Lokasi',
    coordinates: 'Koordinat',
    delete: 'Hapus',
    update: 'Update',
    confirmation: 'Konfirmasi',
    confirmUpdate: 'Apakah Anda yakin ingin menyimpan perubahan data alamat ini?',
    confirmDelete: 'Data alamat yang akan dihapus akan kami hilangkan dan tidak dapat ulangi.',
    no: 'Tidak',
    yes: 'Ya',
    toast: {
      deleteSuccess: 'Alamat Berhasil Dihapus',
      dataSaved: 'Data telah kami simpan',
      locationSelected: 'Lokasi Dipilih',
      locationFailed: 'Gagal Memuat Lokasi',
      tryAgain: 'Silakan coba lagi',
      updateSuccess: 'Alamat Berhasil Diubah',
      addSuccess: 'Alamat Berhasil Ditambahkan'
    }
  }
}
